import { SAVE_TEMPLATE_LOADING, SAVE_TEMPLATE_SUCCESS, SAVE_TEMPLATE_FAILED, CLEAR_TEMPLATE_STATUS,
    FETCH_TEMPLATES_LIST_LOADING, FETCH_TEMPLATES_LIST_SUCCESS, FETCH_TEMPLATES_LIST_FAILED, CLEAR_TEMPLATE_REDUCER,
    FETCH_TEMPLATES_LIST_FILTERED_LOADING, FETCH_TEMPLATES_LIST_FILTERED_SUCCESS, FETCH_TEMPLATES_LIST_PAGINATE_SUCCESS
} from '../actions/verify.action';
import { verifyTemplatesReducer } from '../models/templates.interface';

const initialState: verifyTemplatesReducer = {
    loading: true,
    error: false,
    message: "",
    data: [],
    saveLoading: false,
    total: 0,
    totalTemplates: 0,
    filteredLoading: false
}

const verifyTemplates = (state: verifyTemplatesReducer = initialState, action: any) : verifyTemplatesReducer => {
    switch (action.type) {
        case SAVE_TEMPLATE_LOADING:
            return {
                ...state,
                saveLoading: true
            }
        case SAVE_TEMPLATE_SUCCESS:
            return {
                ...state,
                saveLoading: false,
                data: [action.payload.res, ...state.data],
                total: state.total + 1,
                totalTemplates: state.totalTemplates + 1
            }
        case SAVE_TEMPLATE_FAILED:
            return {
                ...state,
                error: true,
                loading: false,
                saveLoading: false,
                message: action.payload.error.message || ""
            }
        case CLEAR_TEMPLATE_STATUS: 
            return {
                ...state,
                error: false,
                message: ""
            }
        case FETCH_TEMPLATES_LIST_LOADING:
            return {
                ...state,
                loading: true,
                error: false,
                message: ""
            }
        case FETCH_TEMPLATES_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                total: action.payload.total,
                totalTemplates: action.payload.total
            }
        case FETCH_TEMPLATES_LIST_FAILED:
            return {
                ...state,
                loading: false,
                filteredLoading: false,
                error: true,
                message: action.payload.error.message || ""
            }
        case FETCH_TEMPLATES_LIST_PAGINATE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                filteredLoading: false,
                data: [...state.data, ...action.payload.data]
            }
        case FETCH_TEMPLATES_LIST_FILTERED_LOADING: 
            return {
                ...state,
                filteredLoading: true
            }
        case FETCH_TEMPLATES_LIST_FILTERED_SUCCESS:
            return {
                ...state,
                filteredLoading: false,
                data: action.payload.data,
                total: action.payload.total
            }
        case CLEAR_TEMPLATE_REDUCER:
            return initialState;
        default: 
            return state;
    }
}

export default verifyTemplates;